import { Component, OnInit , Input} from '@angular/core';
import { RoutingService } from 'src/app/services/routing.service';

@Component({
  selector: 'app-share',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.scss']
})
export class ShareComponent implements OnInit {

  @Input() name: any;
  @Input() url: any;
  @Input() link: any;
  @Input() class = 'light';
  constructor(
    public route: RoutingService
  ) { }

  ngOnInit(): void {
  }

}
